import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderModel } from "@insite/client-framework/Types/ApiModels";
import { addToCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type ReorderParameter = {
    orderNumber: string;
} & HasOnSuccess &
    HasOnError<string>;

export interface ReorderResult {
    order: OrderModel;
    cartLines?: CartLineCollectionModel;
}

type HandlerType = ApiHandlerDiscreteParameter<ReorderParameter, CartLineCollectionModel, ReorderResult | undefined>;

export const trackAddtoCartEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const state = props.getState();
    const cart = getCurrentCartState(state).value; 
    const order = props.apiResult?.order
    const cartLines = order?.orderLines?.filter(line => line.unitNetPrice > 0 && line.qtyOrdered > 0);
    const totalValue = cartLines?.reduce((sum, item) => {
            return sum + (item.unitNetPrice * item.qtyOrdered);
    }, 0);
    if (cartLines && cart) {
        const newItem =cartLines.map(item => {
            return {
                item_name: item?.shortDescription ? item.shortDescription : item.description,
                item_id: item.productErpNumber,
                quantity: item.qtyOrdered,
                price: item.unitNetPrice,
                item_brand: item?.brand?.name,
            };
        });
        addToCartEvent({
            event: "add_to_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                value: totalValue,
                items: [...newItem],
            },
        });
    }
};

addToChainAfter(chain, SendDataToApi, trackAddtoCartEvent)